import React from "react";
import { Container } from "../styles/container";
import styled from "styled-components";
import { Link } from "react-router-dom";
const Section = styled.section`
  background: rgb(132, 50, 11);
  background: linear-gradient(
    90deg,
    rgba(132, 50, 11, 1) 0%,
    rgba(203, 134, 11, 1) 80%
  );
`;

const Content = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    row-gap: 40px;
  }
`;

const Left = styled.div`
  padding: 30px 0px;

  > h1 {
    font-family: var(--casanova);
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0.2rem;
    line-height: 1.2;
    margin-bottom: 15px;
    text-transform: uppercase;
    @media (max-width: 1399px) {
      font-size: 40px;
    }
    @media (max-width: 1199px) {
      font-size: 32px;
    }
    @media (max-width: 991px) {
      font-size: 26px;
    }
    @media (max-width: 400px) {
      font-size: 20px;
    }
  }
  > p {
    font-size: 16px;
    font-family: var(--montserrat);
    line-height: 1.5;
    margin-bottom: 5px;
    @media (max-width: 567px) {
      font-size: 12px;
    }
  }
  > a {
    background-color: var(--white);
    color: var(--choco);
    border-radius: 20px;
    height: 40px;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    margin-top: 10px;
  }
`;

const Right = styled.div`
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const Bredcrumb = ({
  heading,
  subHeading,
  subHeading2,
  subHeading3,
  link,
  image,
  imgStyleHeight,
  paddingY,
}) => {
  return (
    <Section
      style={paddingY && { paddingTop: paddingY, paddingBottom: paddingY }}
    >
      <Container>
        <Content>
          <Left style={{ padding: paddingY ? "0" : "30px 0px" }}>
            {heading && <h1>{heading}</h1>}
            {subHeading && <p>{subHeading}</p>}
            {subHeading2 && <p>{subHeading2}</p>}
            {subHeading3 && <p>{subHeading3}</p>}
            {link && <Link to={link}>Know More</Link>}
          </Left>
          <Right>
            {image && (
              <img
                src={image}
                alt={image}
                style={{
                  maxHeight: imgStyleHeight ? imgStyleHeight : "auto",
                  objectFit: imgStyleHeight ? "contain" : "cover",
                }}
              />
            )}
          </Right>
        </Content>
      </Container>
    </Section>
  );
};

export default Bredcrumb;
